<script lang="ts">
  import { isLoading } from "$lib/store/loading-context";
  import { browser, dev } from "$app/environment";
  import { setKlaviyo } from "$lib/klaviyo";
  import { uiApi } from "$lib/ui-api";
  import { onMount } from "svelte";
  import type { LayoutData } from "./$types";
  import { afterNavigate } from "$app/navigation";
  import { Modals, closeModal, LoadingContainer, Spinner, openModal } from "@thehood/svlib";

  import { locale } from "$lib/services/i18n";
  import CookieConsent from "$components/modals/cookie-consent.svelte";

  export let data: LayoutData;

  afterNavigate(({ from, to }) => {
    // console.log("test window", window.innerHeight, window.innerWidth);
    const payload = {
      previousPage: from?.url.href,
      currentPage: to?.url.href,
      viewPortHeight: window.innerHeight,
      viewPortWidth: window.innerWidth,
    };
    uiApi.post("/z/uj", payload).catch(err => console.error(`Error recording user journey ${JSON.stringify(err)}`));
  });

  const { headExtras, bodyStartExtras, bodyEndExtras, locale: detectedLocale } = data;
  locale.set(detectedLocale);

  function cookieConsent() {
    // Define dataLayer and the gtag function.
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      dataLayer.push(arguments);
    };

    // Set default consent to 'denied' as a placeholder
    // Determine actual values based on your own requirements
    gtag("consent", "default", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
    });

    const val = localStorage.getItem("ga-cookie-consent");
    if (val === "accepted") {
      setAcceptConsent();
    } else {
      openModal(CookieConsent, { onCloseCallback: setAcceptConsent });
    }
  }

  function setAcceptConsent() {
    if (window?.gtag) {
      gtag("consent", "update", {
        ad_user_data: "granted",
        ad_personalization: "granted",
        ad_storage: "granted",
        analytics_storage: "granted",
      });
      localStorage.setItem("ga-cookie-consent", "accepted");
    }
    if (window?.clarity) {
      // window.addEventListener("consentGranted", () => window.clarity('consent'));
      window.clarity("consent");
    }
  }

  onMount(() => {
    if (browser) {
      setKlaviyo();
      cookieConsent();
    }
  });
</script>

<svelte:head>
  {#if !dev}
    <!-- Google Tag Manager hc with container -->
    <script>
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "//www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", "GTM-KWDJ87");
    </script>
    <!-- End Google Tag Manager hc container-->
  {/if}
  {@html headExtras}
</svelte:head>

{#if dev}
  <div
    style="
      position: fixed;
      height: 1em;
      width: 100%;
      top: 0;
      background: linear-gradient(90deg, Red, Orange, Yellow, Green, Blue, Indigo, violet);
      z-index: 999;
      text-align: center;
      color: #fff;
      font-weight: bold;
      overflow: hidden;
      display: flex;
      justify-content: space-around;
    "
  >
    <div>DEVELOPMENT</div>
    <div>DEVELOPMENT</div>
    <div>DEVELOPMENT</div>
    <div>DEVELOPMENT</div>
    <div>DEVELOPMENT</div>
  </div>
{/if}
{@html bodyStartExtras}
<slot />
{@html bodyEndExtras}

<LoadingContainer show={$isLoading}>
  <Spinner />
</LoadingContainer>

<Modals>
  <div slot="backdrop" class="backdrop" on:click={closeModal} on:keydown={closeModal} role="button" tabindex="0" />
</Modals>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: var(--z2);
  }
</style>
